import { useEffect, useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search])
}
